import { gql } from "@apollo/client";

//TODO: Add more
export const ACCOUNT_FIELDS = gql`
  fragment AccountFields on GQLAccountType {
    id
    internalId
    username
    namePrefix
    firstName
    lastName
    email
    level
    position
    department {
      id
    }
    isStaff
  }
`;
